<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>Deal Library</title>
    <base href="/" />

    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <link rel="icon" sizes="32x32" href="/favicon.ico" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="apple-touch-icon" href="/apple-touch-icon.png" />

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css?family=Figtree:300,400,500,600,700&display=swap" rel="stylesheet" />
    <script type="module" src="/src/main.tsx"></script>
  </head>
  <body>
    <div id="old-browser-warning"><span id="obw-icon">⚠︎</span><span>You are using an outdated browser. Our site may not work optimally.</span></div>
    <style>
      #old-browser-warning {
        display: flex;
        gap: 12px;
        background-color: #FDF9F0;
        color: #0D0D0D;
        padding: 4px 32px;
        font-family: "Figtree", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
      }
      #obw-icon {
        font-size: 18px;
        color: #E8B046;
      }
      @supports (text-orientation: mixed) {
        #old-browser-warning {
          display: none;
        }
      }
    </style>
    <div id="root"></div>
  </body>
</html>
